// extracted by mini-css-extract-plugin
export default {"finboxIntroModal":"FInboxIntroModal_finboxIntroModal__mSGi7"};